export function animatePopupIn(element) {
    gsap.set(element, {display: 'block', autoAlpha: 1, scale: 1.0}); // Zet display op 'block' maar houd het onzichtbaar

    gsap.from(element, {
        duration: 0.5, // Duur van de animatie in seconden
        autoAlpha: 0, // animeert zowel de opacity als de visibility om de popup te tonen/verbergen
        scale: 0.5, // Begint van een geschaalde versie voor een pop-effect
        ease: "power1.out" // Easing functie voor een soepele animatie
    });
    }

export function animatePopupOut(element) {
    // GSAP animatie om de popup te laten verdwijnen
    gsap.to(element, {
        duration: 0.5, // Duur van de animatie in seconden
        autoAlpha: 0, // Animeert zowel de opacity als de visibility om de popup te verbergen
        scale: 0.5, // Eindigt in een geschaalde versie voor een krimp-effect
        ease: "power1.in", // Easing functie voor een soepele animatie
        
    });
}

export function animateBounceFadeInOutRepeat(element) {
    gsap.to(element, {
        duration: 1.5,
        scale: 1.15,
        transformOrigin: "50% 50%",
        ease: "power1.out",
        repeat: -1, // Repeat de animatie zoveel keer als je het element in het DOM hebt
        yoyo: true, // Voer de animatie opnieuw uit om de visibiele status te veranderen
    });

}